(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["host-feature"] && !Shopify.designMode) return;
  try {
    
  /* The inset photograph settles into place once, when the collage comes into view. It is visible
     from the start; only its offset animates, and only without reduced motion (see the CSS). */
  if (!customElements.get('host-feature-collage')) {
    customElements.define(
      'host-feature-collage',
      class HostFeatureCollage extends HTMLElement {
        connectedCallback() {
          if (!('IntersectionObserver' in window)) {
            this.classList.add('is-in');
            return;
          }
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.classList.add('is-in');
                this.observer.disconnect();
              }
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tasting-packages"] && !Shopify.designMode) return;
  try {
    
  /* One guest count, every card. aria-disabled rather than disabled at the limits, so focus stays
     on the button that was pressed (UI/UX review, 2026-10-01). Locale strings arrive as data
     attributes with [placeholders], filled here. */
  if (!customElements.get('tasting-guests')) {
    customElements.define(
      'tasting-guests',
      class TastingGuests extends HTMLElement {
        connectedCallback() {
          this.min = Number(this.dataset.min) || 1;
          this.max = Number(this.dataset.max) || 99;
          this.count = Number(this.querySelector('output').textContent) || this.min;
          this.currency = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency',
            currency: this.dataset.currency || 'GBP',
          });
          this.querySelectorAll('[data-step]').forEach((button) => {
            button.addEventListener('click', () => this.step(Number(button.dataset.step)));
          });
          this.draw(false);
        }

        step(by) {
          const next = this.count + by;
          if (next < this.min || next > this.max) return;
          this.count = next;
          this.draw(true);
        }

        money(pence) {
          const text = this.currency
            .formatToParts(pence / 100)
            .map((part) => part.value)
            .join('');
          return pence % 100 === 0 ? text.replace(/\.00$/, '') : text;
        }

        fill(template, values) {
          let text = template;
          Object.keys(values).forEach((key) => {
            text = text.replace('[' + key + ']', values[key]);
          });
          return text;
        }

        draw(announce) {
          const n = this.count;
          this.querySelector('output').textContent = n;
          this.querySelectorAll('[data-step]').forEach((button) => {
            const atLimit = Number(button.dataset.step) < 0 ? n <= this.min : n >= this.max;
            button.setAttribute('aria-disabled', String(atLimit));
          });
          const said = [this.fill(this.dataset.sayGuests, { count: n })];
          this.querySelectorAll('.tasting-card').forEach((card) => {
            const max = Number(card.dataset.max);
            const full = max > 0 && n > max;
            const total = card.querySelector('[data-total]');
            const link = card.querySelector('.tasting-card__button');
            const label = link.querySelector('[data-label]');
            card.classList.toggle('tasting-card--full', full);
            if (full) {
              total.textContent = this.fill(this.dataset.full, { count: max });
              link.href = link.dataset.enquire;
              label.textContent = link.dataset.fullLabel;
              said.push(this.fill(this.dataset.sayFull, { name: card.dataset.name, count: max }));
            } else {
              const price = this.money(Number(card.dataset.price) * n);
              total.textContent = this.fill(this.dataset.total, { price: price, count: n });
              link.href = link.dataset.href + '?guests=' + n;
              label.textContent = link.dataset.bookLabel;
              said.push(card.dataset.name + ' ' + price);
            }
          });
          if (announce) this.querySelector('[data-say]').textContent = said.join(', ');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wine-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gv-print-button')) {
    customElements.define(
      'gv-print-button',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('button')?.addEventListener('click', () => window.print());
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
